<template>
  <div
    class="TextInput"
    :class="{'has-error': !!errorMessage, success: meta?.valid}"
  >
    <label class="block mb-2" :for="name" v-if="label">
      {{ label }}
    </label>

    <textarea
      class="border border-system-50 bg-system-50 w-full rounded-lg h-36 py-2 px-4 outline-0 focus:border-sky-400 transition-all duration-150 placeholder-gray-100"
      :name="name"
      :id="name"
      :value="inputValue"
      :placeholder="placeholder"
      @input="handleChange"
      @blur="handleBlur"
      :class="[inputClass, {'border-error': errorMessage}]"
      v-if="type == 'textarea'"
    ></textarea>

    <div class="relative" v-else>
      <input
        class="border border-system-50 bg-system-50 w-full rounded-lg h-12 px-4 outline-0 text-xs md:text-base focus:border-sky-400 transition-all duration-150 placeholder-gray-100"
        :name="name"
        :id="name"
        :type="currentType"
        :value="inputValue"
        :placeholder="placeholder"
        @input="handleChange"
        @blur="handleBlur"
        :class="[
          inputClass,
          {'border-error': errorMessage, 'pe-12': type === 'password'},
        ]"
      />
      <p
        class="absolute top-2 end-2 p-2 cursor-pointer"
        v-if="type === 'password'"
        @click="onChangeType"
      >
        <svgIcon
          class="w-5 h-5 fill-current"
          :name="currentType == 'text' ? 'eye-h' : 'eye'"
        />
      </p>
    </div>

    <p class="text-red-500 text-sm mt-2" v-if="errorMessage">
      {{ errorMessage }}
    </p>
  </div>
</template>
<script lang="ts" setup>
import {useField} from "vee-validate";

interface Props {
  type?: string;
  modelValue?: string;
  value?: string;
  name: string;
  inputClass?: string;
  label?: string;
  placeholder?: string;
}

const props = withDefaults(defineProps<Props>(), {type: "text"});
const {name, value, type} = toRefs(props);

const currentType = ref<string>(type.value);

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: value,
});

const onChangeType = () => {
  currentType.value = currentType.value === "password" ? "text" : "password";
};
</script>

<style lang="postcss" scoped>
input,
textarea {
  &.border-error {
    @apply border-red-500;
  }
}
</style>
